<div class="flex flex-row">
  <h4 class="relative whitespace-pre-wrap">
    <ng-content></ng-content>
    @if (showLines) {
    <smatchy-highlight-end-text [mode]="mode"></smatchy-highlight-end-text>
    }
  </h4>
</div>
